export function assignDocument(url: string) {
  window.location.assign(url);
}

export function reloadDocument() {
  window.location.reload();
}
